/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains code for the Password template.
 *
 * @namespace password
 */

(function () {
  var recoverPasswordForm = document.querySelector('#RecoverPassword');
  if (recoverPasswordForm) {
    customerLogin();
  }

  function customerLogin() {
    var config = {
      recoverPasswordForm: '#RecoverPassword',
      hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    };

    checkUrlHash();
    resetPasswordSuccess();

    document.querySelector(config.recoverPasswordForm).addEventListener('click', onShowHidePasswordForm);
    document.querySelector(config.hideRecoverPasswordLink).addEventListener('click', onShowHidePasswordForm);

    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
      var emailValue = document.querySelector('#CustomerEmail').value;
      document.querySelector('#RecoverEmail').value = emailValue;
      document.querySelector('#RecoverPasswordForm').classList.toggle('display-none');
      document.querySelector('#CustomerLoginForm').classList.toggle('display-none');
    }

    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
      var formSuccess = document.querySelector('.reset-password-success');
      // check if reset password form was successfully submited.
      if (formSuccess) {
        document.querySelector('#ResetSuccess').classList.remove('display-none');
      }
    }
  }
})();
